export default __webpack_public_path__ + "static/media/Brescia College.jpg.ff266107.png";